import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import { useCartStore } from '../store/cartStore';
import toast from 'react-hot-toast';

export const LayerPaymentSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { clearCart } = useCartStore();

  const { orderId, paymentDetails } = location.state || {};

  useEffect(() => {
    if (orderId) {
      // Clear cart on successful payment
      clearCart();
      toast.success('Payment successful! Your order has been confirmed.');
    } else {
      // No order data, redirect to home
      navigate('/');
    }
  }, [orderId, clearCart, navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8">
        <div className="text-center">
          <div className="flex justify-center mb-6">
            <CheckCircle className="h-16 w-16 text-green-500" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Payment Successful!</h1>
          <p className="text-gray-600 mb-6">
            Your payment has been verified and your order has been confirmed.
          </p>
          
          {paymentDetails && (
            <div className="bg-gray-50 rounded-lg p-4 text-left mb-6">
              <h3 className="font-semibold text-gray-900 mb-3">Payment Details</h3>
              <div className="space-y-2 text-sm">
                {orderId && (
                  <div className="flex justify-between">
                    <span className="text-gray-600">Order ID:</span>
                    <span className="font-medium">{orderId}</span>
                  </div>
                )}
                {paymentDetails.payment_id && (
                  <div className="flex justify-between">
                    <span className="text-gray-600">Payment ID:</span>
                    <span className="font-medium">{paymentDetails.payment_id}</span>
                  </div>
                )}
                {paymentDetails.amount && (
                  <div className="flex justify-between">
                    <span className="text-gray-600">Amount:</span>
                    <span className="font-medium">₹{paymentDetails.amount}</span>
                  </div>
                )}
                {paymentDetails.status && (
                  <div className="flex justify-between">
                    <span className="text-gray-600">Status:</span>
                    <span className="font-medium text-green-600 capitalize">{paymentDetails.status}</span>
                  </div>
                )}
              </div>
            </div>
          )}
          
          <p className="text-sm text-gray-500 mb-4">
            Redirecting to your orders in a moment...
          </p>
          
          <button
            onClick={() => navigate('/orders')}
            className="btn-primary btn-lg w-full"
          >
            View My Orders
          </button>
        </div>
      </div>
    </div>
  );
};

